// extracted by mini-css-extract-plugin
module.exports = {"container":"ProfileCardListGrid_container__1RjzS","sending":"ProfileCardListGrid_sending__2SrxW"};